<template>
  <div>
    <div class="welcome-container row">
      <div class="col-12 title">متطلبات الانضمام:</div>
    </div>

    <form class="form-step3 w-100 mt-4" @submit.prevent>
      <div class="w-100 mb-4">
        <label class="association-label">خطاب رسمي من صاحب الصلاحية بالانضمام للمنصة</label>
        <div v-if="!payload.auth_letter" class="mt-2">
            <span
              :class="['attachment-container', { 'in-valid': apierrors?.auth_letter }]"
              @click.stop="$refs.auth_letter.$el.click()"
            >
              <img :src="`${staticUrl}/static/images/attachment.png`" alt="attachment" />
              <span class="label">إرفاق المستند</span>
            </span>
        </div>
        <div v-else class="mt-2">
            <div
              class="association-logo d-flex flex-wrap align-items-center justify-content-between file"
            >
              <div class="d-flex align-items-center upload-wrapper">
                <div class="logo-name w-100">
                  <div class="text-truncate">
                    {{ payload.auth_letter.name }}
                  </div>
                  <div>
                    {{ getbytes(payload.auth_letter.size) }}
                  </div>
                </div>
              </div>
              <div class="d-flex align-items-center">
                <button
                    class="btn btn-lg btn-block cancel-btn"
                    type="button"
                    @click.stop="$refs.auth_letter.$el.click()"
                >
                <img :src="`${staticUrl}/static/images/attachment.png`" alt="attachment" style="width: 15px; margin-left: 5px;" />
                  تعديل
                </button>
                <button
                  class="btn btn-lg btn-block cancel-btn"
                  style="margin-right: 0.5rem"
                  @click="$emit('removeFile', 'auth_letter')"
                >
                  إلغاء
                </button>
              </div>
            </div>
        </div>
        <InputText
            ref="auth_letter"
            class="d-none"
            type="file"
            accept="application/pdf"
            @change="(event) => fileAttachmentChange(event, 'auth_letter')"
        />
        <div v-if="doctypeErrors.auth_letter" class="error-message p-invalid mt-2">
          {{doctypeErrors.auth_letter}}
        </div>
      </div>

      <div class="w-100 mb-4">
        <label class="association-label">اللائحة الأساسية</label>
        <div v-if="!payload.basic_regulations" class="mt-2">
            <span
              :class="['attachment-container', { 'in-valid': apierrors?.basic_regulations }]"
              @click.stop="$refs.basic_regulations.$el.click()"
            >
            <img :src="`${staticUrl}/static/images/attachment.png`" alt="attachment" />
              <span class="label">إرفاق المستند</span>
            </span>
        </div>
        <div v-else class="mt-2">
            <div
              class="association-logo d-flex flex-wrap align-items-center justify-content-between file"
            >
              <div class="d-flex align-items-center upload-wrapper">
                <div class="logo-name w-100">
                  <div class="text-truncate">
                    {{ payload.basic_regulations.name }}
                  </div>
                  <div>
                    {{ getbytes(payload.basic_regulations.size) }}
                  </div>
                </div>
              </div>
              <div class="d-flex align-items-center">
                <button
                    class="btn btn-lg btn-block cancel-btn"
                    type="button"
                    @click.stop="$refs.basic_regulations.$el.click()"
                >
                <img :src="`${staticUrl}/static/images/attachment.png`" alt="attachment" style="width: 20px; margin-left: 5px;" />
                  تعديل
                </button>
                <button
                  class="btn btn-lg btn-block cancel-btn"
                  style="margin-right: 0.5rem"
                  @click="$emit('removeFile', 'basic_regulations')"
                >
                  إلغاء
                </button>
              </div>
            </div>
        </div>
        <InputText
            ref="basic_regulations"
            class="d-none"
            type="file"
            accept="application/pdf"
            @change="(event) => fileAttachmentChange(event, 'basic_regulations')"
        />
        <div v-if="doctypeErrors.basic_regulations" class="error-message p-invalid mt-2">
          {{doctypeErrors.basic_regulations}}
        </div>
      </div>

      <div class="w-100 mb-4">
        <label class="association-label">تقرير الحوكمة</label>
        <div v-if="!payload.governance_report" class="mt-2">
            <span
              :class="['attachment-container', { 'in-valid': apierrors?.governance_report }]"
              @click.stop="$refs.governance_report.$el.click()"
            >
            <img :src="`${staticUrl}/static/images/attachment.png`" alt="attachment" />
            <span class="label">إرفاق المستند</span>
            </span>
        </div>
        <div v-else class="mt-2">
            <div
              class="association-logo d-flex flex-wrap align-items-center justify-content-between file"
            >
              <div class="d-flex align-items-center upload-wrapper">
                <div class="logo-name w-100">
                  <div class="text-truncate">
                    {{ payload.governance_report.name }}
                  </div>
                  <div>
                    {{ getbytes(payload.governance_report.size) }}
                  </div>
                </div>
              </div>
              <div class="d-flex align-items-center">
                <button
                    class="btn btn-lg btn-block cancel-btn"
                    type="button"
                    @click.stop="$refs.governance_report.$el.click()"
                >
                <img :src="`${staticUrl}/static/images/attachment.png`" alt="attachment" style="width: 20px; margin-left: 5px;" />
                  تعديل
                </button>
                <button
                  class="btn btn-lg btn-block cancel-btn"
                  style="margin-right: 0.5rem"
                  @click="$emit('removeFile', 'governance_report')"
                >
                  إلغاء
                </button>
              </div>
            </div>
        </div>
        <InputText
            ref="governance_report"
            class="d-none"
            type="file"
            accept="application/pdf"
            @change="(event) => fileAttachmentChange(event, 'governance_report')"
        />
        <div v-if="doctypeErrors.governance_report" class="error-message p-invalid mt-2">
          {{doctypeErrors.governance_report}}
        </div>
      </div>

      <div class="w-100 mb-4">
        <label class="association-label">قوائم مالية لآخر سنة</label>
        <div v-if="!payload.financial_statement" class="mt-2">
            <span
              :class="['attachment-container', { 'in-valid': apierrors?.financial_statement }]"
              @click.stop="$refs.financial_statement.$el.click()"
            >
            <img :src="`${staticUrl}/static/images/attachment.png`" alt="attachment" />
              <span class="label">إرفاق المستند</span>
            </span>
        </div>
        <div v-else class="mt-2">
            <div
              class="association-logo d-flex flex-wrap align-items-center justify-content-between file"
            >
              <div class="d-flex align-items-center upload-wrapper">
                <div class="logo-name w-100">
                  <div class="text-truncate">
                    {{ payload.financial_statement.name }}
                  </div>
                  <div>
                    {{ getbytes(payload.financial_statement.size) }}
                  </div>
                </div>
              </div>
              <div class="d-flex align-items-center">
                <button
                    class="btn btn-lg btn-block cancel-btn"
                    type="button"
                    @click.stop="$refs.financial_statement.$el.click()"
                >
                <img :src="`${staticUrl}/static/images/attachment.png`" alt="attachment" style="width: 20px; margin-left: 5px;" />
                  تعديل
                </button>
                <button
                  class="btn btn-lg btn-block cancel-btn"
                  style="margin-right: 0.5rem"
                  @click="$emit('removeFile', 'financial_statement')"
                >
                  إلغاء
                </button>
              </div>
            </div>
        </div>
        <InputText
            ref="financial_statement"
            class="d-none"
            type="file"
            accept="application/pdf"
            @change="(event) => fileAttachmentChange(event, 'financial_statement')"
        />
        <div v-if="doctypeErrors.financial_statement" class="error-message p-invalid mt-2">
          {{doctypeErrors.financial_statement}}
        </div>
      </div>

      <div class="w-100 mb-4">
        <label class="association-label">قوائم انتظار للمرضى ممن ليس لديهم أهلية علاج في وزارة الصحة</label>
        <div v-if="!payload.patient_waitlist" class="mt-2">
            <span
              :class="['attachment-container', { 'in-valid': apierrors?.patient_waitlist }]"
              @click.stop="$refs.patient_waitlist.$el.click()"
            >
            <img :src="`${staticUrl}/static/images/attachment.png`" alt="attachment" />
              <span class="label">إرفاق المستند</span>
            </span>
        </div>
        <div v-else class="mt-2">
            <div
              class="association-logo d-flex flex-wrap align-items-center justify-content-between file"
            >
              <div class="d-flex align-items-center upload-wrapper">
                <div class="logo-name w-100">
                  <div class="text-truncate">
                    {{ payload.patient_waitlist.name }}
                  </div>
                  <div>
                    {{ getbytes(payload.patient_waitlist.size) }}
                  </div>
                </div>
              </div>
              <div class="d-flex align-items-center">
                <button
                    class="btn btn-lg btn-block cancel-btn"
                    type="button"
                    @click.stop="$refs.patient_waitlist.$el.click()"
                >
                <img :src="`${staticUrl}/static/images/attachment.png`" alt="attachment" style="width: 20px; margin-left: 5px;" />
                  تعديل
                </button>
                <button
                  class="btn btn-lg btn-block cancel-btn"
                  style="margin-right: 0.5rem"
                  @click="$emit('removeFile', 'patient_waitlist')"
                >
                  إلغاء
                </button>
              </div>
            </div>
        </div>
        <InputText
            ref="patient_waitlist"
            class="d-none"
            type="file"
            accept="application/pdf"
            @change="(event) => fileAttachmentChange(event, 'patient_waitlist')"
        />
        <div v-if="doctypeErrors.patient_waitlist" class="error-message p-invalid mt-2">
          {{doctypeErrors.patient_waitlist}}
        </div>
      </div>

    </form>

    <div class="border-container"></div>
    <div class="row">
      <div class="col-lg-6">
        <button
          id="close-btn"
          class="btn btn-lg btn-secondary btn-block close-btn"
          type="button"
          @click.stop="$emit('close')"
        >
          السابق
        </button>
      </div>
      <div class="col-lg-6">
        <button
          id="tracking-btn"
          class="btn btn-lg btn-primary btn-block tracking-btn"
          type="button"
          @click.stop="submit"
        >
          متابعة
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {addStepToCharity, isFileSizeValid, MAX_FILE_SIZE_ERROR_MESSAGE } from "@/helpers/helpers";
export default {
  name: "create-account-step3",
  inject: ["staticUrl"],
  props: ["payload", "apierrors"],
  emits: ["close", "next", "fileChange", "removeFile"],
  data() {
    return {
      submitted: false,
      loading: false,
      doctypeErrors: {
        auth_letter: null,
        basic_regulations: null,
        governance_report: null,
        financial_statement: null,
        patient_waitlist: null,
      },
    };
  },
  methods: {
    fileAttachmentChange(event, key) {
      const allowed_extention = ["pdf"];
      const file = event.target.files[0];

      if (!file) return;

      const file_extention = event.target.files[0].name.split(".").pop();
      if (!allowed_extention.includes(file_extention)) {
        event.target.value = '';
        this.doctypeErrors[key] = 'الرجاء تحميل ملف بصيغة PDF فقط.';
        return;
      }
       // Check file size
      if (!isFileSizeValid(file)) {
        event.target.value = '';
        this.doctypeErrors[key] = MAX_FILE_SIZE_ERROR_MESSAGE;
        return;
      }

        this.$emit("fileChange", event, key);
        this.doctypeErrors[key] = false;

    },
    getbytes(data) {
      if (!data) return "";
      const const_term = 1024;
      let KB, MB, GB, TB;

      KB = (data / const_term).toFixed(3);
      MB = (data / const_term ** 2).toFixed(3);
      GB = (data / const_term ** 3).toFixed(3);
      TB = (data / const_term ** 4).toFixed(3);

      if (TB > 0) {
        return TB + "TB";
      } else if (GB > 0) {
        return GB + "GB";
      } else if (MB > 0) {
        return MB + "MB";
      } else if (KB > 0) {
        return KB + "KB";
      }
      return data + "B";
    },
    async submit() {
      this.submitted = true;
      this.loading = true;

      const step3Payload = {};
      const files = [
        "auth_letter",
        "basic_regulations",
        "governance_report",
        "financial_statement",
        "patient_waitlist",
      ];

      for (const fileKey of files) {
        const file = this.payload[fileKey];
        if (file?.url) {
          step3Payload[fileKey] = {
        url: file.url,
        name: file.name || "",
        size: file.size || 0,
          };
        }
      }

      addStepToCharity("step3", step3Payload);
      this.loading = false;
      this.$emit("next");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.welcome-container {
  .title {
    font-size: 24px;
    font-weight: bold;
  }
}
.error-message {
  color: $color-red-darker;
  font-size: 14px;
}
.attachment-container {
  cursor: pointer;
  background-color: #d9d9d9;
  border-radius: 25px;
  padding: 0.5rem 1rem;
  display: inline-block;

  .label {
    color: #3f3f3f;
    font-size: 18px;
    font-weight: 500;
    margin-right: 0.5rem;
  }
}
.attachment-container.in-valid {
  border: $color-red-darker 1px solid;
  background-color: transparent;
}
.border-container {
  border-top: 1px solid #dadada;
  padding-top: 2rem;
  margin-top: 2rem;
}
.tracking-btn {
  display: block;
  margin: 0 auto;
  width: 80%;
  border-radius: 25px;
  padding: 10px;
  background: #12b2aa;
  color: #ffffff;
  border: none;
  font-size: 18px;
}
.tracking-btn:hover {
  background-color: #0e8e88;
  border: none;
}
.close-btn {
  display: block;
  margin: 0 auto;
  width: 80%;
  border-radius: 25px;
  padding: 10px;
  background: #d9d9d9;
  color: #3f3f3f;
  border: none;
  font-size: 18px;
}
.association-logo {
  height: 80px;
  border-radius: 5px;
  border: 1px dashed #d9d9d9;
  padding: 10px 20px;
  .logo-name {
    color: #8c8c8c;
    font-size: 14px;
  }
  .upload-wrapper {
    width: 73%;
  }
}
.association-label {
  font-size: 14px;
  font-weight: bold;
  display: block;
}
.cancel-btn {
  border-radius: 25px;
  font-size: 14px;
  background-color: #d9d9d9;
  color: #3f3f3f;
  border: none;
}
.cancel-btn:hover {
  background-color: #b2b2b2;
  color: #3f3f3f;
}
</style>